export default {
    en: {
        account: {
            interfaceLanguage: 'Interface Language',
            interfaceLanguageDescription: 'Language support is early in development. Currently, only the Creatures page supports multiple languages, but we\'re working to extend this. If you\'re multilingual and willing to assist, we\'d greatly appreciate your help.',
            interfaceLanguageContributors: 'Interested contributors, please contact us on Discord for coordination. Your support will strengthen our community.',
            languagePreference: 'Preference',
        }
    },
    fr: {
        account: {
            interfaceLanguage: 'Langue de l\'interface',
            interfaceLanguageDescription: 'Le support linguistique est en cours de développement. Actuellement, seule la page des Créatures prend en charge plusieurs langues, mais nous travaillons à son extension. Si vous parlez plusieurs langues et êtes prêt à aider, nous apprécierions grandement votre aide.',
            interfaceLanguageContributors: 'Les contributeurs intéressés sont priés de nous contacter sur Discord pour la coordination. Votre soutien renforcera notre communauté.',
            languagePreference: 'Préférence',
        }
    },
    es: {
        account: {
            interfaceLanguage: 'Idioma de la interfaz',
            interfaceLanguageDescription: 'El soporte de idioma está en desarrollo temprano. Actualmente, solo la página de Criaturas admite varios idiomas, pero estamos trabajando para ampliar esto. Si eres multilingüe y estás dispuesto a ayudar, apreciaríamos mucho tu colaboración.',
            interfaceLanguageContributors: 'Los colaboradores interesados, por favor contáctenos en Discord para coordinarnos. Su apoyo fortalecerá nuestra comunidad.',
            languagePreference: 'Preferencia',
        }
    },
    de: {
        account: {
            interfaceLanguage: 'Oberflächensprache',
            interfaceLanguageDescription: 'Die Sprachunterstützung befindet sich in einem frühen Entwicklungsstadium. Derzeit unterstützt nur die Seite "Kreaturen" mehrere Sprachen, aber wir arbeiten daran, dies auszudehnen. Wenn Sie mehrsprachig sind und bereit sind zu helfen, würden wir Ihre Unterstützung sehr schätzen.',
            interfaceLanguageContributors: 'Interessierte Beitragende können sich bitte auf Discord mit uns in Verbindung setzen, um die Zusammenarbeit zu koordinieren. Ihre Unterstützung wird unsere Community stärken.',
            languagePreference: 'Vorlieben',
        }
    },
    pt: {
        account: {
            interfaceLanguage: 'Idioma da Interface',
            interfaceLanguageDescription: 'O suporte a idiomas está em estágio inicial de desenvolvimento. Atualmente, apenas a página de Criaturas oferece suporte a vários idiomas, mas estamos trabalhando para expandir isso. Se você é multilíngue e está disposto a ajudar, agradecemos muito sua ajuda.',
            interfaceLanguageContributors: 'Colaboradores interessados, por favor, entrem em contato conosco no Discord para coordenação. Seu apoio fortalecerá nossa comunidade.',
            languagePreference: 'Preferência',
        }
    },
    it: {
        account: {
            interfaceLanguage: 'Lingua dell\'interfaccia',
            interfaceLanguageDescription: 'Il supporto linguistico è in fase iniziale di sviluppo. Attualmente, solo la pagina delle Creature supporta più lingue, ma stiamo lavorando per estenderlo. Se sei multilingue e disposto ad aiutare, apprezziamo molto il tuo contributo.',
            interfaceLanguageContributors: 'Contributori interessati, vi preghiamo di contattarci su Discord per coordinarci. Il vostro supporto rafforzerà la nostra comunità.',
            languagePreference: 'Preferenza',
        }
    },
    nl: {
        account: {
            interfaceLanguage: 'Interfacetaal',
            interfaceLanguageDescription: 'Ondersteuning voor talen bevindt zich in een vroeg ontwikkelingsstadium. Momenteel ondersteunt alleen de pagina met Wezens meerdere talen, maar we werken eraan om dit uit te breiden. Als u meertalig bent en bereid bent te helpen, waarderen we uw hulp enorm.',
            interfaceLanguageContributors: 'Geïnteresseerde bijdragers kunnen contact met ons opnemen via Discord voor coördinatie. Uw steun zal onze gemeenschap versterken.',
            languagePreference: 'Voorkeur',
        }
    },
    zh: {
        account: {
            interfaceLanguage: '界面语言',
            interfaceLanguageDescription: '语言支持尚处于早期开发阶段。目前，仅“生物”页面支持多种语言，但我们正在努力扩展支持范围。如果您精通多种语言并愿意提供帮助，我们将不胜感激。',
            interfaceLanguageContributors: '有兴趣的贡献者，请通过Discord与我们联系以协调工作。您的支持将加强我们的社区。',
            languagePreference: '首选语言',
        }
    },
    ja: {
        account: {
            interfaceLanguage: 'インターフェース言語',
            interfaceLanguageDescription: '言語サポートは開発初期段階にあります。現時点では「クリーチャーズ」ページのみが複数の言語をサポートしていますが、これを拡張する作業を進めています。複数の言語に堪能で、お手伝いいただける方がいれば、大変ありがたいです。',
            interfaceLanguageContributors: '興味をお持ちの貢献者の方は、連絡を取るためにDiscordでお知らせいただければ幸いです。皆様のサポートはコミュニティを強化します。',
            languagePreference: '言語設定',
        }
    },
    ru: {
        account: {
            interfaceLanguage: 'Язык интерфейса',
            interfaceLanguageDescription: 'Поддержка языков находится в ранней стадии разработки. В настоящее время только страница с существами поддерживает несколько языков, но мы работаем над расширением этой функции. Если у вас есть знание нескольких языков и вы готовы помочь, мы будем очень признательны.',
            interfaceLanguageContributors: 'Заинтересованные участники, пожалуйста, свяжитесь с нами через Discord для координации. Ваша поддержка укрепит наше сообщество.',
            languagePreference: 'Предпочтение',
        }
    },
};
